import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    name: 1,
    platform: 0,    // 0 = PC, 1 = H5
    userInfo: {},
    showLogin: false,
    showLoginOut: false,
    price: 0,
    qrImgUrl: ''
  },
  mutations: {
    setQrImg(state, value) {
      state.qrImgUrl = value
    },
    setName (state, value) {
      state.name = value
    },
    // eslint-disable-next-line no-unused-vars
    setPlatform (state, value) {
      let timer = null
      let cWidth = ()=> {
        let c_width = window.document.body.clientWidth
        state.platform = c_width < 940 ? 1 : 0
      }
      window.onload = window.onresize = function(){
        timer && clearTimeout(timer)
        timer = setTimeout(()=> {
          cWidth()
          console.log('resize & platform now: ', state.platform)
        }, 0)
      }
      cWidth()
    },
    setUserInfo (state, info) {
      const userId = localStorage.getItem('akc_userId')
      const userPhone = localStorage.getItem('akc_userPhone')
      const userName = localStorage.getItem('akc_userName')
      state.userInfo = info ? info : { userId: userId, userPhone: userPhone, userName: userName }
    },
    setLoginWrap (state, value) {
      state.showLogin = value
    },
    setLoginOutWrap (state, value) {
      state.showLoginOut = value
    },
    setPrice (state, value) {
      state.price = value
    }
  },
  actions: {

  }
})
